import React from 'react';
import PropTypes from 'prop-types';
import ImageHandler from '../../utils/ImageHandler';
import OEmbed from '../OEmbed/OEmbed';

// ====

const Things = (props) => {
  const { content } = props;

  // ====

  return (
    <>
      {content &&
        content.map((node) => {
          return (
            <section key={node._uid}>
              {node.title && <h2>{node.title}</h2>}
              <div className="row">
                {node.content &&
                  node.content.map((item) => {
                    return (
                      <div
                        className={`brand-col col ${item.className}`}
                        key={item._uid}
                      >
                        {item.embed ? (
                          <OEmbed src={item.embed} seo={item.text} />
                        ) : (
                          <>
                            {item.image.filename ? (
                              <img
                                src={ImageHandler(
                                  item.image.filename,
                                  item.dimension,
                                )}
                                className="w-100"
                                alt={item.text}
                              />
                            ) : (
                              <div>{item.text}</div>
                            )}
                          </>
                        )}
                      </div>
                    );
                  })}
              </div>
            </section>
          );
        })}
    </>
  );
};

export default Things;

// ====

Things.propTypes = {
  content: PropTypes.arrayOf,
};

Things.defaultProps = {
  content: null,
};
